import { useMutation } from "react-query";
import { upsertMedicalHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertMedicalHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, onSuccess = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertMedicalHistory(clientId, payload),
    {
      onSuccess: (response: any, variables: any) => {
        showToast({
          message: "Medical history updated successfully",
          errorState: false,
        });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        showToast({
          message: "Whoops! Something went wrong while updating the medical history.",
          errorState: true,
        });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    upsertMedicalHistoryMutation: mutate,
    isUpsertMedicalHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpsertMedicalHistory;
